import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { CompletionRateData } from '@/api/dashboardApi';

interface CompletionRateChartProps {
  data: CompletionRateData;
}

const COLORS = {
  completed: '#10b981', // 녹색
  pending: '#f59e0b',   // 주황색
  failed: '#ef4444',    // 빨간색
};

export const CompletionRateChart: React.FC<CompletionRateChartProps> = ({ data }) => {
  const chartData = [
    { name: '완료', value: data.overall.completed, color: COLORS.completed },
    { name: '대기중', value: data.overall.pending, color: COLORS.pending },
    { name: '실패', value: data.overall.failed, color: COLORS.failed },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>ALT 생성 완료율</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center">
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                paddingAngle={5}
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
          
          {/* 완료율 중앙 표시 */}
          <div className="mt-4 text-center">
            <div className="text-4xl font-bold text-primary">
              {data.overall.completionRate.toFixed(1)}%
            </div>
            <p className="text-sm text-gray-600 mt-1">전체 완료율</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
